import { useMemo } from "react";
import { useQuery } from "react-query";

import { useReactAppState } from "../../shared/containers/utils";
import { fetchClient } from "../../shared/api/fetching";
import { d3MatchesBySportecIdsAPI } from "../../shared/api/variables";

function useForgeMatches({ mlsMatches }) {
    const { apiList } = useReactAppState();

    const matchSportecIds = useMemo(() => mlsMatches?.map(match => match?.match_id)?.filter(Boolean), [mlsMatches]);
    const d3MatchesEndpoint = d3MatchesBySportecIdsAPI({ matchSportecIds });

    return useQuery({
        queryKey: ["d3-matches", matchSportecIds],
        queryFn: () => fetchClient({ endpoint: d3MatchesEndpoint, apiURL: apiList.d3SportsAPI }),
        select: response => {
            const d3MatchList = new Map(response?.map(match => [match?.sportecId, match]));
            return d3MatchList;
        },
        enabled: matchSportecIds?.length > 0,
    });

}

export default useForgeMatches;
